import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi, { ICreateApplicationRequest } from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createCreateApplicationThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(
    ApplyProcessActionTypes.CreateApplication,
    async (data: ICreateApplicationRequest) => {
      const response = await api.createApplication(data);
      return response;
    },
  );
